var _defs, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftRectangeDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 751.741,
    height: 780.557,
    viewBox: "0 0 751.741 780.557",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.186,
    y1: 1.15,
    x2: 0.736,
    y2: -0.061,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6a700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#070707"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "left-rectange-dark",
    width: 621.86,
    height: 573.648,
    rx: 191,
    transform: "translate(539.053) rotate(70)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftRectangeDark);
export default __webpack_public_path__ + "static/media/left-rectange-dark.ecc1b091cab8cd9fd8e2e4b42bf60c6f.svg";
export { ForwardRef as ReactComponent };